import { useNavigate } from 'react-router-dom';

import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
} from 'shared/lib';

import {
  AppSettingsFormData,
  ConnectedAppSettingsForm,
  prepareRequestData,
  useAddSettingsMutation,
} from 'entities/settings';

import { ADD_ERROR, ADD_SUCCESS } from '../consts';
import { APP_SETTING_ROUTES } from 'shared/consts/routes/app-settings';

const initialValues: AppSettingsFormData = {
  id: '',
  countryId: '',
  userAgreementUrl: '',
  urlFaq: '',
  supportPhone: '',
  telegrammBot: '',
  statusTimeOut: '',
  stopChargingRequestTimeout: '',
};

export function AddAppSettings() {
  const [trigger, { isLoading }] = useAddSettingsMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: AppSettingsFormData) => {
    const { id, ...rest } = prepareRequestData(values);

    try {
      const res = await trigger(rest).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);

        return;
      }
      //

      openSuccessNotification(ADD_SUCCESS);

      navigate(`${APP_SETTING_ROUTES.APP_SETTINGS}/${res.settings.id}`);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : ADD_ERROR;

      openErrorNotification(errorText);
    }
  };

  return (
    <ConnectedAppSettingsForm
      title="Добавление новых настроек"
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      loading={isLoading}
    />
  );
}
